.root {
  display: flex;
  height: 100%;
  overflow: hidden;
}

/* ── Left panel: Conversation browser ────────────────────── */

.leftPanel {
  width: 240px;
  flex-shrink: 0;
  border-right: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--color-surface);
}

/* ── Center panel: Chat ───────────────────────────────────── */

.chatPanel {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ── Right panel: Studio ──────────────────────────────────── */

.rightPanel {
  width: 300px;
  flex-shrink: 0;
  border-left: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--color-surface);
}

/* ── Shared panel chrome ──────────────────────────────────── */

.panelHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--sp-4);
  height: 44px;
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.panelTitle {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

/* ── New conversation button ──────────────────────────────── */

.newConvBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: var(--radius-sm);
  background: rgba(56,189,248,0.08);
  border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s;
}
.newConvBtn:hover { background: rgba(56,189,248,0.15); }

/* ── Conversation list ────────────────────────────────────── */

.convList {
  flex: 1;
  overflow-y: auto;
  padding: var(--sp-2) 0;
}

.convGroup {
  margin-bottom: var(--sp-3);
}

.convGroupLabel {
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-text-faint);
  padding: var(--sp-3) var(--sp-4) var(--sp-1);
}

.convItem {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  text-align: left;
  padding: var(--sp-3) var(--sp-4);
  background: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: background 0.12s;
  position: relative;
}
.convItem:hover { background: rgba(56,189,248,0.04); }
.convActive { background: rgba(56,189,248,0.08) !important; }
.convActive .convTitle { color: var(--color-sky); }

.convItemRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
}

.convTitle {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.convTime {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  flex-shrink: 0;
}

.convPreview {
  font-size: 11px;
  color: var(--color-text-faint);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}

/* ── Empty conversation state ─────────────────────────────── */

.emptyConvs {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-10) var(--sp-4);
  text-align: center;
}

.emptyConvsIcon {
  font-size: 20px;
  color: var(--color-border-med);
}

.emptyConvsText {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-faint);
}

.emptyConvsStart {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-sky);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: var(--sp-1) 0;
}
.emptyConvsStart:hover { text-decoration: underline; }

/* ── Studio tabs ──────────────────────────────────────────── */

.studioTabs {
  display: flex;
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.studioTab {
  flex: 1;
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 10px 0;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--color-text-faint);
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s;
  margin-bottom: -1px;
}
.studioTab:hover { color: var(--color-text-muted); }
.studioTabActive { color: var(--color-sky) !important; border-bottom-color: var(--color-sky); }

/* ── Studio body ──────────────────────────────────────────── */

.studioBody {
  flex: 1;
  overflow-y: auto;
  padding: var(--sp-3);
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

/* ── Asset cards ──────────────────────────────────────────── */

.assetCard {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  overflow: hidden;
  transition: border-color 0.15s;
}
.assetCard:hover { border-color: var(--color-border-med); }

.assetChartWrap {
  width: 100%;
  height: 180px;
  pointer-events: none;
}

.assetCardFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-3);
  border-top: 1px solid var(--color-border);
}

.assetCardTitle {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.pinWrap {
  position: relative;
  flex-shrink: 0;
}

.pinMenuDropdown {
  position: absolute;
  bottom: calc(100% + 4px);
  right: 0;
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  border-radius: var(--radius-md);
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
  min-width: 130px;
  z-index: 100;
  overflow: hidden;
}

.pinMenuItem {
  display: block;
  width: 100%;
  text-align: left;
  font-family: var(--font-mono);
  font-size: 11px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background 0.1s, color 0.1s;
}
.pinMenuItem:hover { background: rgba(56,189,248,0.08); color: var(--color-sky); }

.pinBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  background: rgba(56,189,248,0.08);
  border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.12s;
}
.pinBtn:hover:not(:disabled) { background: rgba(56,189,248,0.16); }
.pinBtn:disabled { cursor: default; }
.pinBtnDone {
  background: rgba(52,211,153,0.08) !important;
  border-color: rgba(52,211,153,0.2) !important;
  color: #34d399 !important;
}

/* ── Empty Studio state ───────────────────────────────────── */

.emptyStudio {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-10) var(--sp-4);
  text-align: center;
}

.emptyStudioIcon {
  font-size: 24px;
  color: var(--color-border-med);
}

.emptyStudioText {
  font-size: 12px;
  color: var(--color-text-faint);
  line-height: 1.6;
  max-width: 210px;
}

.emptyStudioLink {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-sky);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: var(--sp-1) 0;
}
.emptyStudioLink:hover { text-decoration: underline; }

/* ── Studio shared chats ───────────────────────────────────── */

.sharedCard {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  text-align: left;
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-3);
  cursor: pointer;
  transition: border-color 0.15s;
}
.sharedCard:hover { border-color: var(--color-border-med); }

.sharedCardRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
}

.sharedCardTitle {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

/* ── Studio KPI cards ─────────────────────────────────────── */

.kpiCard {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-3);
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  transition: border-color 0.15s;
}
.kpiCard:hover { border-color: var(--color-border-med); }

.kpiLabel {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.kpiValue {
  font-family: var(--font-mono);
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: -0.5px;
  line-height: 1.1;
}

.kpiMeta {
  display: flex;
  gap: var(--sp-2);
  align-items: center;
  flex-wrap: wrap;
}

.kpiModel {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
}

.kpiDate {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
}

.kpiCalcBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  background: rgba(56,189,248,0.08);
  border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky);
  cursor: pointer;
  align-self: flex-start;
  margin-top: var(--sp-1);
  transition: background 0.12s;
}
.kpiCalcBtn:hover { background: rgba(56,189,248,0.16); }
.kpiCalcBtn:disabled { opacity: 0.5; cursor: default; }

/* ── Recommendations ──────────────────────────────────────── */

.recommendationsHeader {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  flex-wrap: wrap;
}

.recommendationsLastReviewed {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  flex: 1;
}

.docBadgeDone {
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 3px;
  background: rgba(45,212,191,0.08);
  border: 1px solid rgba(45,212,191,0.2);
  color: var(--color-teal-bright);
}

.docBadgeFail {
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 3px;
  background: rgba(239,68,68,0.08);
  border: 1px solid rgba(239,68,68,0.2);
  color: var(--color-error);
}

.recCard {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-3);
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  transition: border-color 0.15s;
}
.recCard:hover { border-color: var(--color-border-med); }

.recCardHeader {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
}

.recPriority {
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 3px;
  background: rgba(56,189,248,0.08);
  border: 1px solid rgba(56,189,248,0.2);
  color: var(--color-sky);
}
.recPriority_high {
  background: rgba(239,68,68,0.08);
  border-color: rgba(239,68,68,0.2);
  color: var(--color-error);
}
.recPriority_medium {
  background: rgba(245,158,11,0.08);
  border-color: rgba(245,158,11,0.2);
  color: var(--color-warn);
}
.recPriority_low {
  background: rgba(34,197,94,0.08);
  border-color: rgba(34,197,94,0.2);
  color: var(--color-success);
}

.recCategory {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-text-faint);
}

.recTitle {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  line-height: 1.4;
}

.recRationale {
  font-size: 12px;
  color: var(--color-text-muted);
  line-height: 1.5;
}

.recActions {
  display: flex;
  gap: var(--sp-2);
  margin-top: var(--sp-1);
}

.recDismissBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid var(--color-border-med);
  color: var(--color-text-faint);
  cursor: pointer;
  align-self: flex-start;
  margin-top: var(--sp-1);
  transition: background 0.12s, color 0.12s;
}
.recDismissBtn:hover { background: rgba(239,68,68,0.08); color: var(--color-error); border-color: rgba(239,68,68,0.2); }
